import { useQuery } from '@apollo/client';
import { FETCH_MINI_HIGHLIGHT_DEAL_QUERY } from './queries/MiniDealHighlightQuery';
import PropertyRecord from 'customer-data-objects/property/PropertyRecord';
// @ts-expect-error dependency missing types
import { toSubject } from 'customer-data-sidebar/graphQL/parse';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import getIn from 'transmute/getIn';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const truncateProp = {
  lineClamp: 2
};
const MiniDealHighlight = ({
  subjectId,
  objectType
}) => {
  const {
    data: miniDealHighlightQueryResults,
    error,
    loading
  } = useQuery(FETCH_MINI_HIGHLIGHT_DEAL_QUERY, {
    variables: {
      subjectId,
      objectType
    }
  });
  if (!miniDealHighlightQueryResults || loading || error) {
    return null;
  }
  const amountProperty = PropertyRecord(getIn(['crmObject', 'defaultProperties', 'amount', 'definition'], miniDealHighlightQueryResults));
  const subject = toSubject(objectType, miniDealHighlightQueryResults.crmObject);
  const value = getProperty(subject, 'amount');
  return /*#__PURE__*/_jsx(View, {
    overflow: "hidden",
    "data-test-id": "mini-deal-highlight",
    children: /*#__PURE__*/_jsxs(Text, {
      as: "h2",
      typography: "heading-50",
      truncate: truncateProp,
      "data-test-id": "mini-deal-highlight-title",
      children: [/*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: objectType,
        objectId: subjectId,
        property: amountProperty,
        value: value,
        getAdditionalPropertyValue: propertyName => getProperty(subject, propertyName)
      }), ` ${getProperty(subject, 'dealname')}`]
    })
  });
};
export default MiniDealHighlight;